<!--
 * @Author: Merlin
 * @Date: 2024-06-06 17:39:15
 * @LastEditors: Merlin
 * @LastEditTime: 2024-09-27 13:37:17
 * @Description: 
-->
<template>
    <button class="picker-wrap"
        :class="{
            [sClassName]: true,
        }"
    >
        <span class="trigger-content__text">
            <!-- ↓显示浏览器记录值，服务器取不到 --> 
            <ClientOnly>
                {{ oCurOption.label }}
            </ClientOnly>
        </span>
        <IconSvgUse
            use="icon-arrow-down"
            class="arrow"
            :class="{turn: bMenuShowing}"
        />
        <!-- ■■■■■■■■■■■■■■■■■■■■■■■■■ -->
        <q-menu
            :offset="[0, 15]" 
            :anchor="(`top right` as any)"
            v-bind="oMenuPosition" 
            @update:model-value="fnMenuVisibleStatusReceiver"
            :ref="el => oMenu = el"
        >
            <ul class="pop-box" >
                <li class="item"
                    v-for="(cur, idx) of aOptions"
                    :class="{active: cur.value === iRangeMs }"
                    :key="idx"
                    @click="rangeSetter(cur)"
                >
                    {{ cur.label }}
                </li>
            </ul>
        </q-menu>
    </button>
</template>

<script setup lang="ts">
import {
    aTickOptions
} from '../ts/wavesData';
import {
    settingsState_f,
    fnGetChartStateToolbox_oi,
} from '@/pages/casino/futuresGame/ts/wavesControlCenter';

const props = defineProps({
    skin: {
        type: String, 
    },
});

const oChartStateToolbox = fnGetChartStateToolbox_oi();
const bMenuShowing = ref(false); 
const oMenu = ref(null); // 记录 DOM 元素 
const aOptions = reactive(aTickOptions);
const iRangeMs = computed(()=>{
    return settingsState_f.currentPeriod;
});

// ↓ 当前选定  
const oCurOption = computed(()=>{
    const oResult = aOptions.find(cur=>{
        return cur.value === iRangeMs.value;
    });
    return oResult;
});

const sClassName = computed(()=>{
    if (props.skin === 'label'){
        return 'be-label';
    }
    return 'be-button';
});

const oMenuPosition = computed(()=>{
    if (props.skin === 'label'){
        return {
            fit: true,
            self: "top right",
            anchor: "bottom right",
        };
    }
    return {
        fit: true,
        self: "top middle",
        anchor: "bottom middle",
    }
});

// ============================ ↑ 各种数据 =========================
// ============================ ↓ 相关方法 =========================

// ↓监听菜单显/隐 
function fnMenuVisibleStatusReceiver(bVisible){
    // console.log("菜单可见性：", bVisible); 
    bMenuShowing.value = bVisible;
}

// ↓ 切换频率（设定频率）  
async function rangeSetter(oTarget){
    console.log("设定频率：", oTarget);
    oMenu.value.hide(); 
    await Sleep(100); 
    oChartStateToolbox.unsubscribeOnAggregatedPrices();
    // ↑ 先关闭旧的订阅
    // ↓ 立即订阅新的，防止被其它故障阻碍提交的执行 
    const rangeMs = oTarget.value; 
    settingsState_f.currentPeriod = rangeMs;
    // ↓ 内部有执行赋值和清空旧数据的操作，以及按须修改 type 类型 
    // ↓ 同时 type 类型变化会触发 TheWaveChart.vue 内部的一些清空动作  
    oChartStateToolbox.setSelectedTick(rangeMs);
    oChartStateToolbox.getPairHistory({
        rangeMs,
    });
    // ↓ 为新的频率订阅数据等操作
    oChartStateToolbox.subscribeOnAggregatedPrices();
}

</script>


<style scoped lang="scss"> 
.picker-wrap{
    display: flex;
    align-items: center; 
    justify-content: space-between;
    .arrow {
        transform: rotate(0);
        transition: fill .1s ease-in-out, transform .1s ease-in-out;
        &.turn {
            transform: rotate(180deg);
        }
    }
}

.be-button{
    border-radius: 8px;
    font-size: 12px;
    height: 30px;
    padding: 7px 13px;
    background-color: rgb(22 31 44 / var(--tw-bg-opacity));
    transition: background-color .1s ease-in-out, border-color .1s ease-in-out; 
    &:hover{
        background-color: rgba(255,255,255, 0.1);
    }
    .trigger-content__text{
        font-weight: 600;
        line-height: 12px;
        white-space: nowrap;
        color: white;
        margin-right: 3px; 
    }
    svg{
        width: 13px;
        height: 13px;
        fill: var(--color_grey-20);
        color: var(--color_grey-20);
        pointer-events: none;
    }
}

.be-label{
    width: 100%; 
    svg{
        width: 18px; 
        height: 18px; 
    }
}


// ==== ↓ 弹出气泡 ========================

.pop-box{
    // min-width: 90px;
    height: 300px;
    overflow-y: scroll;
    border-radius: 8px;
    font-size: 12px;
    padding: 6px 10px;
    background-color: var(--color_dark-shades-gray-100);
    box-shadow: 2px 2px 20px #0000004d;
    li{
        align-items: center;
        color: var(--color_grey-40);
        display: flex;
        outline: none;
        text-align: left;
        transition: color .1s ease-in-out;
        width: 100%;
        letter-spacing: -.24px;
        line-height: 20px;
        padding: 5px 6px;
        cursor: pointer;
        font-weight: 600; 
        &.active{
            background-color: var(--color_grey-60);
            color: white; 
            border-radius: 5px; 
        }
        &:hover{
            color: white; 
        }
    }
}
</style>



